"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestrictiveCovenants$ = exports.RestrictiveCovenants$outboundSchema = exports.RestrictiveCovenants$inboundSchema = void 0;
exports.restrictiveCovenantsToJSON = restrictiveCovenantsToJSON;
exports.restrictiveCovenantsFromJSON = restrictiveCovenantsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.RestrictiveCovenants$inboundSchema = z.object({
    associated_property_description: z.nullable(z.string()),
    unique_identifier: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "associated_property_description": "associatedPropertyDescription",
        "unique_identifier": "uniqueIdentifier",
    });
});
/** @internal */
exports.RestrictiveCovenants$outboundSchema = z.object({
    associatedPropertyDescription: z.nullable(z.string()),
    uniqueIdentifier: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        associatedPropertyDescription: "associated_property_description",
        uniqueIdentifier: "unique_identifier",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var RestrictiveCovenants$;
(function (RestrictiveCovenants$) {
    /** @deprecated use `RestrictiveCovenants$inboundSchema` instead. */
    RestrictiveCovenants$.inboundSchema = exports.RestrictiveCovenants$inboundSchema;
    /** @deprecated use `RestrictiveCovenants$outboundSchema` instead. */
    RestrictiveCovenants$.outboundSchema = exports.RestrictiveCovenants$outboundSchema;
})(RestrictiveCovenants$ || (exports.RestrictiveCovenants$ = RestrictiveCovenants$ = {}));
function restrictiveCovenantsToJSON(restrictiveCovenants) {
    return JSON.stringify(exports.RestrictiveCovenants$outboundSchema.parse(restrictiveCovenants));
}
function restrictiveCovenantsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.RestrictiveCovenants$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'RestrictiveCovenants' from JSON`);
}
//# sourceMappingURL=restrictivecovenants.js.map